import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cb6b8aba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: { width: '100%', fontSize: '0.8rem' } }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", {
    rowspan: "2",
    class: "text-center",
    width: "30"
  }, "TT"),
  /*#__PURE__*/_createElementVNode("th", {
    colspan: "2",
    class: "text-center",
    width: "120"
  }, "Hoá Đơn"),
  /*#__PURE__*/_createElementVNode("th", {
    colspan: "2",
    class: "text-center break-word",
    width: "120"
  }, "Phiếu nhập"),
  /*#__PURE__*/_createElementVNode("th", {
    rowspan: "2",
    class: "text-center break-word",
    width: "55"
  }, "Mã VT"),
  /*#__PURE__*/_createElementVNode("th", {
    rowspan: "2",
    class: "text-center break-word",
    width: "200"
  }, "Tên vật tư"),
  /*#__PURE__*/_createElementVNode("th", {
    rowspan: "2",
    class: "text-center break-word",
    width: "120"
  }, "Đặc tính"),
  /*#__PURE__*/_createElementVNode("th", {
    rowspan: "2",
    class: "text-center break-word",
    width: "40"
  }, "Đơn vị tính"),
  /*#__PURE__*/_createElementVNode("th", {
    colspan: "3",
    class: "text-center",
    width: "210"
  }, "Nhập trong kỳ")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", {
    class: "text-center",
    width: "30"
  }, "Số"),
  /*#__PURE__*/_createElementVNode("th", {
    class: "text-center",
    width: "90"
  }, "Ngày"),
  /*#__PURE__*/_createElementVNode("th", {
    class: "text-center",
    width: "30"
  }, "Số"),
  /*#__PURE__*/_createElementVNode("th", {
    class: "text-center",
    width: "90"
  }, "Ngày"),
  /*#__PURE__*/_createElementVNode("th", {
    class: "text-center",
    width: "70"
  }, "Số lượng"),
  /*#__PURE__*/_createElementVNode("th", {
    class: "text-center",
    width: "70"
  }, "Đơn giá"),
  /*#__PURE__*/_createElementVNode("th", {
    class: "text-center",
    width: "70"
  }, "Thành tiền")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "text-center fst-italic" }, "A"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-center fst-italic" }, "B"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-center fst-italic" }, "C"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-center fst-italic" }, "D"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-center fst-italic" }, "E"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-center fst-italic" }, "F"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-center fst-italic" }, "G"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-center fst-italic" }, "H"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-center fst-italic" }, "I"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-center fst-italic" }, "1"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-center fst-italic" }, "2"),
  /*#__PURE__*/_createElementVNode("td", { class: "text-center fst-italic" }, "3 = 1 * 2")
], -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "12",
  class: "text-center fst-italic"
}, "Không có dữ liệu", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { class: "break-word" }
const _hoisted_12 = { class: "break-word" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_14 = { class: "break-word" }
const _hoisted_15 = { class: "text-end" }
const _hoisted_16 = { class: "text-end" }
const _hoisted_17 = { class: "text-end fw-bolder" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "fw-bolder text-center",
  colspan: "9"
}, " Cộng ", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, "-", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, "-", -1))
const _hoisted_21 = { class: "text-end fw-bolder" }

import { computed, PropType } from 'vue';
import { IHoaDonNhapKhoResponseBase } from '@/core/interfaces/ApiResponses';
import { useDateTime } from '@/core/hooks/use-date-time-hook';
import { formatCurrencyAndQuantity } from '@/core/helpers/utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChiTietNhapTable',
  props: {
  items: {
    type: Array as PropType<IHoaDonNhapKhoResponseBase[]>,
    default: () => [],
  },
},
  setup(__props) {

const props = __props;

const { formatDisplayingDate } = useDateTime();

const sttCal = (indexHoaDon, indexVatTu) => {
  let curIndex = 0;

  for (let i = 0; i < indexHoaDon; i++) {
    curIndex += props.items[i].vat_tu_nhap_kho.length;
  }

  return curIndex += 1 + indexVatTu;
}

const totalNhapTrongKy = computed(() => {
  let result = 0;

  props.items.forEach(({ vat_tu_nhap_kho: vatTuNhapKho }) => {
    vatTuNhapKho.forEach(({ pivot: { don_gia, so_luong } }) => {
      result += +don_gia * +so_luong
    })
  })

  return formatCurrencyAndQuantity(Math.round(result), false);
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    (!__props.items.length)
      ? (_openBlock(), _createElementBlock("tr", _hoisted_5, _hoisted_7))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (hoaDon, indexHoaDon) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: hoaDon.id
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hoaDon.vat_tu_nhap_kho, (vatTu, indexVatTu) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: vatTu.id
                }, [
                  _createElementVNode("td", _hoisted_8, _toDisplayString(sttCal(indexHoaDon, indexVatTu)), 1),
                  _createElementVNode("td", _hoisted_9, _toDisplayString(hoaDon.so_hoa_don ?? '-'), 1),
                  _createElementVNode("td", null, _toDisplayString(_unref(formatDisplayingDate)(new Date(hoaDon.ngay_hoa_don))), 1),
                  _createElementVNode("td", _hoisted_10, _toDisplayString(hoaDon.so_phieu), 1),
                  _createElementVNode("td", null, _toDisplayString(_unref(formatDisplayingDate)(new Date(hoaDon.ngay_hoan_thanh))), 1),
                  _createElementVNode("td", _hoisted_11, _toDisplayString(vatTu.ma_vat_tu), 1),
                  _createElementVNode("td", _hoisted_12, _toDisplayString(vatTu.ten_vat_tu), 1),
                  _hoisted_13,
                  _createElementVNode("td", _hoisted_14, _toDisplayString(vatTu.don_vi_tinh), 1),
                  _createElementVNode("td", _hoisted_15, _toDisplayString(_unref(formatCurrencyAndQuantity)(vatTu.pivot.so_luong)), 1),
                  _createElementVNode("td", _hoisted_16, _toDisplayString(_unref(formatCurrencyAndQuantity)(vatTu.pivot.don_gia)), 1),
                  _createElementVNode("td", _hoisted_17, _toDisplayString(_unref(formatCurrencyAndQuantity)(
              Math.round(+vatTu.pivot.so_luong * +vatTu.pivot.don_gia),
              false,
            )), 1)
                ]))
              }), 128))
            ], 64))
          }), 128)),
          _createElementVNode("tr", null, [
            _hoisted_18,
            _hoisted_19,
            _hoisted_20,
            _createElementVNode("td", _hoisted_21, _toDisplayString(totalNhapTrongKy.value), 1)
          ])
        ], 64))
  ]))
}
}

})